<template>
	<div class="location-button">
		<button @click="$emit('locateMe')" :class="{selected:showingMe}" v-if="!showingMe"><div class="dot"></div>Var är jag?</button>
		<button @click="$emit('zoomAll')" :class="{selected:showingAll}" v-if="!showingAll"><img src="@/assets/Stockholms_Basta_symbol_pos-22xauto.png" />Hela banan</button>
	</div>
</template>

<script>
export default {

	props: {
		"showingMe": Boolean,
		"showingAll": Boolean,
	}
}
</script>

<style scoped>
	.location-button {
		position: absolute;
		bottom: 130px;
		left: 0;
		right: 0;

		display:flex;
		flex-flow: row nowrap;
		justify-content: center;
		z-index: 900000000;
		pointer-events: none;
	}

	.location-button button {
		cursor: pointer;
		font-family: 'Poppins', sans-serif;
		font-weight: 700;
		font-size: 16px;
		background: white;
		background: #ffffffaa;
		border: none;
		border-radius: 30px;
		padding: 3px 12px;
		margin: 0 2px;
		pointer-events: auto;
	}

	.location-button button:focus {
		outline: none;
		/* box-shadow: 0px 0px 4px black; */
	}

	.location-button button:hover {
		background-color: white;
	}

	.location-button button.selected {
		opacity: .4;
	}

	.location-button button img {
		width: 22px;
		margin-right: 3px;
	}

	.dot {
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 10px;
		background-color: #1da1f2;
		margin-right: 5px;
	}
</style>